import { createContext, Dispatch, SetStateAction } from 'react';

export interface MessagesContext {
    showChannels: boolean;
    setShowChannels: Dispatch<SetStateAction<boolean>>;
}

export const MessagesCtx = createContext<MessagesContext>({} as MessagesContext);
